var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6H13C14.1 6 15 6.9 15 8V14C15 15.1 14.1 16 13 16H3C1.9 16 1 15.1 1 14V8C1 6.9 1.9 6 3 6H4V4C4 1.8 5.8 0 8 0C10.2 0 12 1.8 12 4V6ZM8 2C6.9 2 6 2.9 6 4V6H10V4C10 2.9 9.1 2 8 2ZM3 8V14H13V8H3ZM9 12C9 12.55 8.55 13 8 13C7.45 13 7 12.55 7 12V10C7 9.45 7.45 9 8 9C8.55 9 9 9.45 9 10V12Z"
  })));
};
export default SvgLock;